import moment from 'moment';
import { shippingDisplayDays } from './ShippingDisplay';
import { mergeShippingRows, normalizeShippingSchedule, shippingRecords, shippingRecordId } from './shippingConfig';

export const SHIPPING_BOARD_CONTRACT = { response: { envelope: [], includeMappedKeys: false } };

export function shippingDataEntryParams(startDate, endDate) {
  // Fetch the whole selected range so local search/status filters and saved
  // views paginate over all matches, not just the first API page.
  return {
    requirePackDue: true,
    excludeJobStatus: 'Excluded',
    dateField: 'DisplayDate',
    ...(startDate ? { dateFrom: startDate } : {}),
    ...(endDate ? { dateTo: endDate } : {}),
    sortBy: 'DisplayDate',
    sortOrder: 'ASC',
  };
}

export function shippingBoardParams(today, range) {
  const days = shippingDisplayDays(today, range);
  return {
    requirePackDue: true,
    excludeJobStatus: 'Excluded',
    skipSundays: true,
    today,
    dateField: 'DisplayDate',
    dateFrom: moment(today).subtract(5, 'days').format('YYYY-MM-DD'),
    dateTo: days[days.length - 1] || today,
    sortBy: 'DisplayDate',
    sortOrder: 'ASC',
    page: 1,
    limit: 500,
  };
}

export function normalizeShippingBoard(payload) {
  const entries = shippingRecords(payload);
  const jobs = normalizeShippingSchedule(entries);
  // An optional shipping join may have no row yet. Preserve POST-on-first-edit.
  const records = entries.filter((entry) => shippingRecordId(entry) != null);
  const rows = mergeShippingRows(jobs, records);
  return [...new Map(rows.map((row) => [String(row.ProjectId), row])).values()];
}
